import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex'

//开发所需方法与组件 start

// import echarts from 'echarts'// 引入echarts
import './assets/elementUi/components.js' //element组件引用
import './api/axios.js' //axios引用 示例：this.$axiso.请求方式
import baseAPI from './api/base.js' //公共api
import './api/customOrder.js' //自定义指令
import DialogFieldDesc from './components/common/DialogFieldDesc.vue'

Vue.component('dialog-field-desc', DialogFieldDesc)

// import VueSocketIO from 'vue-socket.io'
// import io from 'socket.io-client'
// import { VirtualScroller, RecycleScroller } from 'vue-virtual-scroller'

import 'element-ui/lib/theme-chalk/index.css' //element样式
// import 'element-ui/lib/theme-chalk/index.css' //element样式
import 'element-ui/lib/theme-chalk/base.css'

// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

Vue.prototype.$baseAPI = baseAPI //挂载api对象到实例 示例：this.$baseAPI.方法名
// Vue.prototype.$io = io; //挂载api对象到实例 示例：this.$io.方法名
//开发所需方法与组件 end
//import AMap from 'vue-amap';

Vue.config.productionTip = false

// Vue.prototype.$VERSION = VERSION
// Vue.use(AMap);
// // Vue.use(VueVirtualScroller)
// // Vue.component('VirtualScroller', VirtualScroller);
// // Vue.component('RecycleScroller', RecycleScroller);
// AMap.initAMapApiLoader({
// 	key: "ddc3f919a2106d25341cb70eba4b5c1e", //平台申请的key值
// 	plugin: ['AMap.InfoWindow', 'AMap.Autocomplete',
// 		'AMap.PlaceSearch', 'AMap.Scale',
// 		'AMap.OverView', 'AMap.ToolBar',
// 		'AMap.MapType', 'AMap.PolyEditor',
// 		'AMap.CircleEditor', 'AMap.Geolocation', 'AMap.MouseTool',
// 		'AMap.InfoWindow', 'AMap.GraspRoad', 'AMap.TrackCorrector', 'AMap.TrajectorySimplifier', 'AMap.Driving'
// 	],
// 	version: "1.4.4", // amap版本
// 	uiVersion: '1.0', //添加 uiVersion 的脚本版本号  这个很重要!必须要引入
// });
//高德的安全密钥
window._AMapSecurityConfig = {
	securityJsCode: '10e9d5e2a4cb4090da1e956220221342',
}
new Vue({
  router,
  store,
  render: function(h) {
    return h(App)
  },
}).$mount('#app')
